import { useCallback } from 'react'

import { useApp } from '../../contexts/AppContext'
import { BannerKind } from '../../types/contexts/AppContext'

export const useWidgetErrorBanner = () => {
  const { showBanner } = useApp()

  return useCallback(
    (message: string) =>
      showBanner({
        kind: BannerKind.ERR,
        msg: message,
      }),
    [showBanner]
  )
}
